import React, { Component } from "react";
import AceEditor from "react-ace";
import { Container, Typography, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import API from "./MyApi";
import { useNavigate } from "react-router-dom";

// Import the Python mode for Ace Editor
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-monokai";

function ViperCodeView() {
  const { state } = useLocation();
  // Define a state to hold the content of the editor
  const [code, setCode] = React.useState(state);
  const navigate = useNavigate();


  return (
    <Container className="form">
      <Typography
        variant="h4"
        noWrap
        sx={{
          mr: 2,
          fontFamily: "monospace",
          fontWeight: 700,
          color: "inherit",
          textDecoration: "none",
          textAlign: "center",
        }}
      >
        Output
      </Typography>

      <AceEditor
        mode="python" // Set the editor mode to Python
        theme="monokai" // Set the editor theme
        onChange={setCode} // Set a function to handle onChange event
        name="python_editor" // Unique name for the editor instance
        editorProps={{ $blockScrolling: true }}
        fontSize={14} // Set font size
        showPrintMargin={false} // Show a print margin
        showGutter={true} // Show line numbers
        highlightActiveLine={true} // Highlight the current line
        value={code} // Set the value of the editor
        width="100%" // Set width
        height="80vh" // Set height
      />
    </Container>
  );
}

export default ViperCodeView;
